// Auto-generated version file
// This gets updated on each build
export const APP_VERSION = '1.8.0';
export const BUILD_DATE = new Date().toISOString();
export const BUILD_TIMESTAMP = Date.now();
